import instance from '../../../api/axios'

export const loadFolders = async (parentId?: string): Promise<any> => {
  const response = await instance.get('/files/folders', {
    params: parentId ? { parentId } : undefined,
  })

  return response.data
}

export default loadFolders
